import { render, staticRenderFns } from "./dataChoice.vue?vue&type=template&id=1ac4b20a&"
import script from "./dataChoice.vue?vue&type=script&lang=js&"
export * from "./dataChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/items/dataChoice.vue"
export default component.exports